import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Authentication is cookie-based (httpOnly `auth_token` set by the backend on
 * login/register, and `session_token` for OAuth). withCredentials forwards
 * cookies on every request. We no longer read tokens from localStorage in
 * order to mitigate XSS-based token theft.
 */
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
